import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Assignment } from "./../shared/model/model";

import { CommonModule } from "@angular/common";
import { PlannerIndicatorDirective } from "../shared/components/plannerindicator.component";

@Component({
  selector: "app-assignment-indicator",
  standalone: true,
  imports: [CommonModule, PlannerIndicatorDirective],
  templateUrl: "assignment-indicator.component.html",
  styleUrls: ["assignment-indicator.component.scss"],
})
export class AssignmentIndicatorComponent {
  @Input() assignment: Assignment;
  @Output() cellclick = new EventEmitter();

  constructor() {}

  clickCell(event: Event) {
    this.cellclick.emit(event);
  }
}
